<template>
    <div :class="['visual-flat', {'is-show': isReady}]">
        <Canvas modify="visual-canvas_page_floor"/>
        <Vr modify="visual-vr_theme_flat"/>
        <Sly/>
        <Breadcrumbs modify="visual-breadcrumbs_theme_flat"/>
        <Compass modify="visual-compass_theme_flat"/>
        <Filters/>
    </div>
</template>

<style lang="scss">
    @import "./Flat.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Canvas from '../../components/Canvas/Canvas';
import Compass from '../../components/Compass/Compass';
import Filters from '../../components/Filters/Filters';
import Sly from '../../components/Sly/Sly';
import store from '../../store';
import Vr from '../../components/Vr/Vr';

export default {
    components: {
        Canvas,
        Sly,
        Compass,
        Breadcrumbs,
        Vr,
        Filters
    },

    computed: {...mapGetters({isReady: 'GET_IS_READY'})},

    methods: {...mapActions(['send'])},

    beforeRouteEnter(to, from, next) {
        /**
         * Отправляет данные на сервер.
         */
        const body = {
            step    : 'flat',
            building: to.params.buildingId || '',
            section : to.params.sectionId || '',
            floor   : to.params.floorId || ''
        };

        store.dispatch('send', body).then(() => {
            next();
        });
    }
};
</script>
